import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CoreLegacyModule } from '@isophi/core-legacy';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';

import { SharedModule } from '../../shared/shared.module';
import { TransitionReportComponent } from './transition-report.component';
import { TransitionReportRoutingModule } from './transition-report-routing.module';

@NgModule({
  imports: [
    CommonModule,
    TransitionReportRoutingModule,
    CoreLegacyModule,
    NgbModule,
    SharedModule,
    FormsModule,
    NgSelectModule,
    ReactiveFormsModule,
  ],
  declarations: [TransitionReportComponent],
})
export class TransitionReportModule {}
